module.exports = "/_next/static/images/4b7be71023fdf8dcadffdfd6fb3ccf0c-circles.svg.webp";